import { useMemo } from 'react';
import { FieldCondition, FieldRuleOnForm, IForm, customSWRConfig } from '../../model/types';
import useFormById from './useFormById';

type ListenedConditionOnForm = FieldCondition & { conditionFieldKey: string };
type UIFieldRuleOnForm = FieldRuleOnForm & {
    listenedConditionOnForm: ListenedConditionOnForm;
};
type UIForm = Omit<IForm, 'fields'> & { fields: UIFieldRuleOnForm[] };

// function refactorDevPurpose(data: IForm): IForm {
//     if (!data) return data;
//     const newFields = data.fields.map((fieldRuleOnForm) => {
//         if (fieldRuleOnForm.key === 'ts.priority') {
//             return {
//                 ...fieldRuleOnForm,
//                 conditions: [
//                     {
//                         action: {
//                             fieldKey: 'ts.type',
//                             required: { type: 'TRUE' as any, ids: [] },
//                             visibility: true
//                         },
//                         value: ['7']
//                     }
//                 ]
//             };
//         }
//         if (fieldRuleOnForm.key === 'ts.subject') {
//             return {
//                 ...fieldRuleOnForm,
//                 conditions: [
//                     {
//                         action: {
//                             fieldKey: 'ts.tags',
//                             required: { type: 'TRUE' as any, ids: [] },
//                             visibility: true
//                         },
//                         value: ['asdf']
//                     }
//                 ]
//             };
//         }
//         if (fieldRuleOnForm.key === 'ts.assignee') {
//             return {
//                 ...fieldRuleOnForm,
//                 required: { type: 'STATUS' as any, ids: [2, 3] }
//             };
//         }

//         return fieldRuleOnForm;
//     });

//     return { ...data, fields: newFields };
// }

/**
 * The function transforms a field rule on a form by adding a listened condition based on the field
 * key.
 * @param {IForm} form - The `form` parameter is of type `IForm`, which represents a form object.
 * @returns a transformed version of the input `form` object. The transformed object is of type
 * `UIForm` and has the same properties as the input `form` object, except that the `fields` property
 * has been modified. The `fields` property is an array of `UIFieldRuleOnForm` objects, where each
 * object has been refactored to include a `list
 */
export function transformFieldRuleOnForm(form: IForm): UIForm {
    if (!form) return form as UIForm;

    const refactoredFields: UIForm['fields'] = form.fields.map((fieldRuleOnForm, _index, fieldRuleListOnForm) => {
        let refactoredFieldRuleOnForm = fieldRuleOnForm as UIFieldRuleOnForm;

        let i = form.fields.length;
        while (--i >= 0) {
            // TS2339: Property 'findLast' does not exist on type 'FieldCondition[]'
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const listenedConditionOnForm = fieldRuleListOnForm[i].conditions.findLast(
                ({ action: { fieldKey } }) => fieldKey === fieldRuleOnForm.key
            ) as ListenedConditionOnForm;

            if (listenedConditionOnForm) {
                listenedConditionOnForm.conditionFieldKey = fieldRuleListOnForm[i].key;
                refactoredFieldRuleOnForm = { ...refactoredFieldRuleOnForm, listenedConditionOnForm };
                break;
            }
        }
        return refactoredFieldRuleOnForm;
    });

    return {
        ...form,
        fields: refactoredFields
    };
}

export default function useAgentFormById(id: number, config: customSWRConfig = {}) {
    const { data } = useFormById(id, config);
    const refactoredAgentFormById = useMemo(() => transformFieldRuleOnForm(data), [data]);

    return refactoredAgentFormById;
}

export { type ListenedConditionOnForm, type UIFieldRuleOnForm, type UIForm };
